import type { IconButtonProps } from '@mui/material';
import MuiIconButton from '@mui/material/IconButton';
import type { LinkProps as RouterLinkProps } from '@tanstack/react-router';
import { DelayedTooltip } from '@src/shared/ui/Tooltip';
import type { TooltipProps } from '@src/shared/ui/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';

export interface ExtendedIconButtonProps extends IconButtonProps {
  to?: string;
  params?: RouterLinkProps['params'];
  href?: string;
  component?: ElementType;
  fontSize?: 'medium' | 'small';
  tooltipTitle?: string;
  tooltipProps?: Partial<TooltipProps>;
}

const IconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  ({ tooltipTitle, tooltipProps, children, ...props }, ref) => {
    const button = (
      <MuiIconButton ref={ref} {...props}>
        {children}
      </MuiIconButton>
    );

    if (!tooltipTitle || props.disabled) {
      return button;
    }

    return (
      <DelayedTooltip title={tooltipTitle} {...tooltipProps}>
        {button}
      </DelayedTooltip>
    );
  },
);

IconButton.displayName = 'IconButton';
export default IconButton;
